import { Snackbar } from "@mui/material";
import { createContext, useContext, useState, useEffect } from "react";
import { useAuth } from "./Auth/AuthPage.jsx";
import * as Sentry from "@sentry/react";

const RSVPContext = createContext();
const BACKEND_HOST = process.env["REACT_APP_BACKEND_HOST"];

export const RSVPProvider = ({ children }) => {
    const {loggedIn} = useAuth();
    const [leadFollowCount, setLeadFollowCount] = useState({});
    const [snackBarOpen, setSnackBarOpen] = useState(false);
    const [snackBarMessage, setSnackBarMessage] = useState("");

    const updateLeadFollowCount = async(callback) => {
        if (!loggedIn) {
            return {};
        }

        try {
            const res = await fetch(`${BACKEND_HOST}/rsvps`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${window.localStorage.getItem("authToken")}`
                }
            })
            if (res.ok) {
                setLeadFollowCount(await res.json());
            }
            if (typeof callback === "function") {
                setTimeout(() => callback.call(), 100);
            }
        } catch (e) {
            Sentry.captureException(e);
            setLeadFollowCount({});
            return {};
        }
    };
    

    useEffect(() => {
        updateLeadFollowCount();

        const i = setInterval(updateLeadFollowCount, 300 * 1000);

        return () => {
            clearInterval(i);
        };
    }, [loggedIn]);

    const isRSVP = (rsvpKey) => {
    
        return leadFollowCount.hasOwnProperty(rsvpKey) && leadFollowCount[rsvpKey].selected === 1;
    }

    const toggle = async (rsvpKey, setLoading) => {

        setLoading(true);
        if (isRSVP(rsvpKey) && leadFollowCount[rsvpKey].selected === 1) {
            const res = await fetch(`${BACKEND_HOST}/rsvp/${rsvpKey}`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${window.localStorage.getItem("authToken")}`
                }
            })

            setSnackBarMessage(res.ok ? "Star removed successfully" : "Failed to remove star");
        } else {
            const res =await fetch(BACKEND_HOST + "/rsvp", {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${window.localStorage.getItem("authToken")}`
                },
                body: JSON.stringify({ rsvpKey })
            })
          
            setSnackBarMessage(res.ok ? "Star added successfully" : "Failed to add star");
        }

        setSnackBarOpen(true)
        updateLeadFollowCount(() => setLoading(false));
    };

    const counts = (rsvpKey) => {
        if (leadFollowCount.hasOwnProperty(rsvpKey)) {
            return leadFollowCount[rsvpKey];
        }
        return { leads: 0, follows: 0, other: 0, total: 0 };
    }

    return (
        <RSVPContext.Provider value={{
            leadFollowCount: leadFollowCount,
            isRSVP: isRSVP,
            toggle: toggle,
            counts: counts,
            setSnackBarMessage,
            setSnackBarOpen
        }}>
            <Snackbar 
                open={snackBarOpen}
                message={snackBarMessage}
                autoHideDuration={2000}
                onClose={() => setSnackBarOpen(false)} />
            {children}
        </RSVPContext.Provider>
    );
};

    
export const useRSVP = () => useContext(RSVPContext);